

const PrintIcon = ({ onClick }) => {
    return (
        <svg
            width="20"
            height="20"
            onClick={onClick}
            className="cursor-pointer"
            viewBox="0 0 561 526"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path fill="#B8AEC0" d="M141.4 35.95L132.8 103.15H427.325L418.725 35.95C418.725 15.625 402.325 0 382 0H177.3C156.975 0 141.35 15.625 141.35 35.95H141.4ZM35.95 139.85H524.225C544.55 139.85 560.175 155.475 560.175 175.8V389.875C560.175 410.2 544.55 425.825 524.225 425.825H457.825V525.05H102.35V425.825H35.95C15.625 425.825 0 410.2 0 389.875V175.8C0 155.475 15.625 139.85 35.95 139.85ZM421.875 489.075V257.05H138.275V489.075H421.875ZM379.7 324.225H176.575C171.875 324.225 167.975 319.525 167.975 314.85V303.9C167.975 299.2 171.875 295.3 176.575 295.3H379.7C384.4 295.3 389.075 299.2 389.075 303.9V314.85C389.075 319.55 384.375 324.225 379.7 324.225ZM379.7 389.075H176.575C171.875 389.075 167.975 384.375 167.975 379.7V368.75C167.975 364.05 171.875 360.15 176.575 360.15H379.7C384.4 360.15 389.075 364.05 389.075 368.75V379.7C389.075 384.4 384.375 389.075 379.7 389.075ZM379.7 453.9H176.575C171.875 453.9 167.975 449.2 167.975 444.525V433.575C167.975 428.875 171.875 424.975 176.575 424.975H379.7C384.4 424.975 389.075 428.875 389.075 433.575V444.525C389.075 449.225 384.375 453.9 379.7 453.9Z" />
        </svg>
    )
}
export default PrintIcon;